import React, { Component } from 'react'
import {
  Container,
  Grid,
  Segment,
  Form,
  Header,
  Message
} from 'semantic-ui-react'

// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { passwordReset } from '../actions/user'

class PasswordReset extends Component {
  state = {
    password: '',
    newPassword: '',
    confirmPassword: ''
  }
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit(e) {
    const { password, newPassword } = this.state
    const { id } = this.props.user.detail
    this.props.passwordReset({
      id,
      password,
      newPassword
    })
    this.setState({
      password: '',
      newPassword: '',
      confirmPassword: ''
    })
    e.preventDefault()
  }

  render() {
    const { pwReset, detail } = this.props.user
    const { username } = detail
    const { password, newPassword, confirmPassword } = this.state
    const match =
      newPassword === confirmPassword &&
      (newPassword !== '' && confirmPassword !== '') &&
      newPassword.length > 5
    return (
      <Container>
        <Grid centered>
          <Grid.Column computer={6} tablet={6} mobile={16}>
            <Header as="h3">Password Reset</Header>
            <p>Change your password below.</p>
            <Segment>
              <Form>
                <Form.Input
                  name="username"
                  label="Username"
                  placeholder="Username"
                  value={username}
                  disabled
                />
                <Form.Input
                  name="password"
                  label="Password"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={this.handleChange.bind(this)}
                />
                <Form.Input
                  name="newPassword"
                  label="New Password"
                  placeholder="New Password"
                  type="password"
                  value={newPassword}
                  onChange={this.handleChange.bind(this)}
                />
                <Form.Input
                  name="confirmPassword"
                  label="Confirm Password"
                  placeholder="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  onChange={this.handleChange.bind(this)}
                />
                <small>Ensure password is at least 5 characters long.</small>
                <br />
                <br />
                {pwReset
                  ? <Message content="Password Reset Successful!" />
                  : null}

                <Form.Button
                  fluid
                  onClick={this.handleSubmit.bind(this)}
                  disabled={!match}
                >
                  {!match ? 'New Passwords Do Not Match' : 'Change Password'}
                </Form.Button>
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    ui: state.ui
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      passwordReset
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset)



// WEBPACK FOOTER //
// ./src/pages/PasswordReset.jsx